<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
    >
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{row.code}}</span>
      </template>
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <img
            v-if="row.mainImage"
            :src="row.mainImage"
            width="50px"
            height="50px"
          />
          <div>
            <p>产品ID：{{ row.productId }}</p>
            <span>{{ row.productName }}</span>
            <div v-if="row.capacity">
              容量：{{ row.capacity }}{{ row.unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 采用结果 -->
      <template #isUseSlot="{ row }">
        <div>
          <span>
            {{ row.isUse ? (row.isUse === 'YES' ? '采用' : '不采用') : '' }}
          </span>
          <el-tooltip
            v-if="row.reason"
            effect="dark"
            :content="row.reason"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
    </CommonTable>
    <!-- 弹框 -->
    <el-dialog center top="5vh" :visible.sync="dialogVisible" width="1300px">
      <OutsideSample v-if="dialogVisible && status === 'detail'" :id="id" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import OutsideSample from '@/components/OutsideSample';
export default {
  components: { CommonTable, SampleSearchForm, OutsideSample },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      listForm: { statusList :  ['PASS', 'REJECT', 'DELETE', 'COMPLETE'] },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        { label: '产品名称', prop: 'productName' },
        { 
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot'
        },
        { label: '申请时间', prop: 'createDate' },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'unit', width: 80 },
        { label: '样品类型', prop: 'productTypeName', width: 100 },
        { label: '供应商', prop: 'supplierName' },
        { label: '申请人', prop: 'demandStaffName' },
        { label: '需求品牌', prop: 'demandBrandName' },
        { label: '用途', prop: 'purpose' },
        { label: '审核结果', prop: 'checkStatusName', width: 100 },
      ],
      tableDataTab: {},
      dialogVisible: false,
      status: '',
      id: ''
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .getCheckOrderListAll(params)
        .then(result => {
          this.tableDataTab = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 修改
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    }
  },
};
</script>

<style lang="less" scoped>
</style>
